// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overflow-hidden[data-v-c0d775d4]{overflow:hidden!important}", "",{"version":3,"sources":["webpack://./resources/js/Components/BillingAndAccounting/ManualInvoices/DocumentPreSavePreview.vue"],"names":[],"mappings":"AACA,kCACI,yBAAA","sourcesContent":["\n.overflow-hidden {\n    overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
